import React from 'react';

function Avatar(ref) {
  let mention = ref.mention;
  let refTheme = ref.theme;
  let theme = refTheme === undefined? {}: refTheme;


  if (mention.get('avatar')) {
    return <img
      src={mention.get('avatar')}
      className={theme.mentionSuggestionsEntryAvatar}
      role='presentation'
    />
  }

  if (mention.get('firstName')) {
    let diskNumber = mention.get('iconId');
    let diskClass = 'avatar-' + diskNumber;

    let letters = getAvatarLetters(mention.get('firstName'), mention.get('secondName'));

    return (
      <span
        className={'' + theme.mentionSuggestionsEntryAvatar + ' ' + diskClass}
        role='presentation'
      >
        {letters}
      </span>
    );
  }

  return null;
}

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

export default function Entry(props){
  let { mention, theme, searchValue } = props;
  let parentProps = _objectWithoutProperties(props, ['mention', 'theme', 'searchValue']);

    return (
    <div
      {...parentProps}
    >
        <Avatar
          mention={mention}
          theme={theme}
        />

        <span className={theme.mentionSuggestionsEntryText}>
          {mention.get('name')}
        </span>

      </div>
    );
  }

function getAvatarLetters(firstName, secondName) {
  let firstLetter = firstName && firstName.charAt(0) || '';
  let lastLetter;

  if (secondName) {
    lastLetter = secondName && secondName.charAt(0) || '';
  } else {
    let everythingAfterAtSymbol = /@.*$/;
    let everythingAfterPlusSymbol = /\+.*$/;
    let nonLetters = /[^a-zA-Z]+/;
    let strParts = firstName
      .replace(everythingAfterAtSymbol, '')
      .replace(everythingAfterPlusSymbol, '')
      .split(nonLetters);

    lastLetter = strParts.length > 1 && strParts[1].charAt(0) || '';
  }
  return (firstLetter + lastLetter).toUpperCase();
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/mention-editor-entry.es6